import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  getPeriod(params) {
    return axiosInstance.get('/master/report_target_asset/log', {
      params,
      cancelToken: getNewCancelToken(),
    });
  },
};
